import { api, unwrap } from './client';

/**
 * Budgets API client.
 *
 * Backend wraps every response in ApiResponse<T>; always pass through unwrap().
 * Paths begin with /finance/budgets. All endpoints are ADMIN/SUPERADMIN only,
 * with budget creation/admin reads scoped to FINANCE department.
 *
 * BudgetResponse shape: { id, department, projectId, category, allocatedAmount,
 * usedAmount, remainingAmount, utilizationPercent, year, quarter, createdBy,
 * createdAt }
 */

export async function listBudgets({ year } = {}) {
  const res = await api.get('/finance/budgets', {
    params: year != null ? { year } : undefined,
  });
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listBudgetsByDept(dept, year) {
  const res = await api.get(`/finance/budgets/dept/${dept}`, {
    params: year != null ? { year } : undefined,
  });
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function getBudget(id) {
  const res = await api.get(`/finance/budgets/${id}`);
  return unwrap(res);
}

/**
 * Create a budget. Backend treats creation as idempotent for the
 * (department, category, projectId, year, quarter) key.
 */
export async function createBudget(payload) {
  const res = await api.post('/finance/budgets', payload);
  return unwrap(res);
}
